<template lang="pug">

  v-dialog(v-model="showTermsModal" :width="'100%'" max-width="800px" :persistent="true")

    .dialogHeader

      .dialogHeaderTitle
        | Termos de uso

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close()")

    .dialogBody

      .dialogBodyContent

        iframe(
          :src="termsUrl"
          width="100%"
          height="600px"
          frameborder="0"
          style="border: none;"
        )

        .text-right.mt-4
          sos-button(@buttonClick="close()" buttonLabel="Fechar" size="medium")

</template>

<script>

  import SosButton from '@/components/SosButton'
  import TERMS_OF_USE_URL from '@/constants/termsUrl.js'

  export default {
    name: 'ModalTermsOfUse',

    components: {
      // 'terms-of-use': TermsOfUse, // Componente removido
      'sos-button': SosButton,
    },

    data: () => ({
      showTermsModal: false,
      termsUrl: TERMS_OF_USE_URL,
    }),

    methods: {
      //
      //
      //

      open () {
        this.showTermsModal = true
      },

      //
      //
      //

      close () {
        this.showTermsModal = false
      },
    },
  }

</script>

<style scoped>
.dialogBodyContent {
  overflow: hidden;
}
</style>
